import * as React from "react"

const Icon = (props) => (
  <svg
    data-name="Group 837"
    xmlns="http://www.w3.org/2000/svg"
    width={17.001}
    height={17}
    {...props}
  >
    <path
      d="M70.506.012a.531.531 0 0 0-.494.667l1.77 6.635L79.6 8.51l-7.815 1.2-1.771 6.637a.531.531 0 0 0 .752.612L86.7 8.985a.531.531 0 0 0 0-.949L70.765.067a.531.531 0 0 0-.258-.055z"
      transform="translate(-69.994 -.011)"
      style={{
        fill: "#00446e",
      }}
    />
  </svg>
)

export default Icon